module.exports = __webpack_public_path__ + "img/windpointer.5dae64e2.svg";